import { Menu, MenuItem } from "@headlessui/react";
import {
  EllipsisVerticalIcon,
  ViewfinderCircleIcon,
} from "@heroicons/react/24/outline";

/**
 * Compact sticky-Actions kebab with a single "View Details" item.
 * Used on Status dashboard grids (and similar one-action tables).
 */
export default function ViewDetailsActionMenu({
  onViewDetails,
  disabled = false,
}) {
  if (disabled) return null;

  return (
    <Menu as="div" className="relative inline-flex justify-center">
      <Menu.Button
        className="inline-flex items-center justify-center rounded-md p-1.5 text-gray-400 hover:bg-gray-50 hover:text-gray-500 focus:outline-none"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="sr-only">Open options</span>
        <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
      </Menu.Button>
      <Menu.Items
        anchor="bottom end"
        portal
        className="z-[100] mt-2 w-52 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none shadow-ring"
      >
        <MenuItem>
          {({ focus }) => (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onViewDetails?.(e);
              }}
              className={`${
                focus ? "bg-gray-50" : ""
              } flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm text-gray-900`}
            >
              <ViewfinderCircleIcon
                className="h-4 w-4 text-gray-400"
                aria-hidden="true"
              />
              View Details
            </button>
          )}
        </MenuItem>
      </Menu.Items>
    </Menu>
  );
}
